import { useState, useEffect } from "react";
import { fetchInstallmentsMap } from "@/services/financeiro";

/**
 * Mapa billId → total de parcelas (Sienge installmentsNumber).
 * Um fetch ao montar a página (janela fixa no servidor); não depende do filtro de datas da tela.
 */
export function useInstallmentsMap(): Map<string, number> | null {
  const [map, setMap] = useState<Map<string, number> | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchInstallmentsMap().then((m) => {
      if (!cancelled) setMap(m);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return map;
}
